import { updateMySettings } from "@healthshare/shared/commands/account"
import { useBackendApi } from "./useBackendApi"
import { setSettings } from "../reduxToolkit/membershipSlice"
import { useAppDispatch } from "./reduxToolkit"
import { useAsyncEffect } from "./useAsyncEffect"
import { useSession } from "../providers/supabase"

/**
 * Loads the caller's settings, creating the row if they have none.
 *
 * This used to be getOrCreateSettingsForUser(), a PostgREST upsert living in
 * packages/shared -- which meant the package the SDK is built from shipped a
 * direct member write. `PATCH /backend/settings/mine` with an empty body has
 * the same get-or-create semantics server-side, so the load and the save are
 * one operation rather than two code paths that can disagree about whether a
 * row exists. See docs/plans/native-app-sdk-seams.md, Stage 2 Step 4.
 */
export function useLoadSettingsFromServer() {
  const api = useBackendApi()
  const dispatch = useAppDispatch()
  const userId = useSession()?.user?.id

  return useAsyncEffect(async () => {
    if (!userId) { return }

    const settings = await updateMySettings(api, {})
    dispatch(setSettings({ settings }))
  }, [api, dispatch, userId])
}
